import { transport } from 'config/transport';

export function callApiExportAnnualReportThuChiCTPV(congDoanId, academicYear, pdf = false) {
    return transport.get(`/ctpv/thuchi/congDoan/${congDoanId}/exportAnnualReport`, { params: { academicYear, pdf }, responseType: 'blob' });
}
